import { AbstractFormComponent } from '../abstract/abstract-form.component';
import { CommonVerbsApiService } from '@services/common/common-verbs-api.service';
import { Component } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { Inject } from '@angular/core';
import { MigForm } from '@models/forms/mig-form.model';
import { ModelService } from '@services/common/model.service';
import { Renderer2 } from '@angular/core';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-memory-care-form',
  templateUrl: './memory-care-form.component.html',
  styleUrls: ['../../mig-form.component.scss'],
})
export class MemoryCareFormComponent extends AbstractFormComponent {
  constructor(
    builder: FormBuilder,
    @Inject('MigFormService')
    service: ModelService<MigForm>,
    api: CommonVerbsApiService,
    renderer: Renderer2,
    toastr: ToastrService,
    @Inject('ID_MEMORY_CARE_MIG_FORM') idMigForm: string
  ) {
    super(builder, service, api, renderer, toastr, idMigForm, 'memory_care');
  }
}
